import { accountScope } from './account-scope';
const KEY = 'vriti_product_tour:v1';
const START_FLAG = 'vriti_product_tour_start';
export const TOUR_START_EVENT = 'vriti:product-tour-start';
function storageKey() {
    const scope = accountScope();
    return scope ? `${KEY}:${scope}` : null;
}
export function readTourState() {
    const key = storageKey();
    if (!key)
        return null;
    try {
        const parsed = JSON.parse(localStorage.getItem(key) || 'null');
        return parsed && typeof parsed.status === 'string' ? parsed : null;
    }
    catch (_a) {
        return null;
    }
}
export function writeTourState(status, step) {
    const key = storageKey();
    if (!key)
        return;
    // A manual restart must not undo an earlier "completed": keep the strongest outcome.
    const prev = readTourState();
    const next = (prev === null || prev === void 0 ? void 0 : prev.status) === 'completed' && status !== 'completed'
        ? Object.assign(Object.assign({}, prev), { updatedAt: Date.now() }) : { status, step, updatedAt: Date.now() };
    try {
        localStorage.setItem(key, JSON.stringify(next));
    }
    catch (_a) {
        // Storage blocked: the tour still works, it just may be offered again.
    }
}
/** From any page's profile menu: start the tour once the dashboard is showing. */
export function requestTourStart() {
    try {
        sessionStorage.setItem(START_FLAG, String(Date.now()));
    }
    catch (_a) {
        // Without sessionStorage the event below still covers "already on the dashboard".
    }
    window.dispatchEvent(new Event(TOUR_START_EVENT));
}
/**
 * True once per request; clears it. A request older than a minute is dropped, so
 * one whose navigation was cancelled (e.g. "Stay on this page") doesn't start the
 * tour on some later visit.
 */
export function takeTourStartRequest() {
    try {
        const at = Number(sessionStorage.getItem(START_FLAG));
        if (!at)
            return false;
        sessionStorage.removeItem(START_FLAG);
        return Date.now() - at < 60000;
    }
    catch (_a) {
        return false;
    }
}
